import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

import AOS from "aos";
import "aos/dist/aos.css";
import "../ui/common.css";
import "../Styles/mobile-res.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import homeimage1 from "../Asstes/Images/home-customer-1.jpg";
import listicon from "../Asstes/Images/lists-icon.svg";
import vision from "../Asstes/Images/vison.svg";
import experience from "../Asstes/Images/expericne.svg";

import img1 from "../Asstes/Images/line1.png";
import img2 from "../Asstes/Images/line-img-2.png";
import img3 from "../Asstes/Images/line-img-3.png";

import sl1 from "../Asstes/Images/home-review-logo-1.svg";
import sl2 from "../Asstes/Images/home-review-logo-2.png";
import sl3 from "../Asstes/Images/home-review-logo-3.svg";
import sl4 from "../Asstes/Images/home-review-logo-4.png";
import sl5 from "../Asstes/Images/home-review-logo-5.png";
import sl6 from "../Asstes/Images/home-review-logo-6.png";

import blogImg1 from "../Asstes/Images/blog-01.png";
import blogImg2 from "../Asstes/Images/blog-02.png";
import blogImg3 from "../Asstes/Images/rejected-blog-img.jpg";

import homepageVideo from "../Asstes/Images/homepage-video.mp4";
import mapImage from "../Asstes/Images/map-img.png";

import config from "../config";

const Home = () => {
  const navigate = useNavigate();
  const [banner, setBanner] = useState(null);
  const [section1, setSection1] = useState(null);
  const [section2, setSection2] = useState(null);
  const [section3, setSection3] = useState(null);
  const [section4, setSection4] = useState(null);
  const [section5, setSection5] = useState(null);
  const [section6, setSection6] = useState(null);
  const [section7, setSection7] = useState(null);
  const [section8, setSection8] = useState(null);
  const [contentData, setContentData] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [blogs, setBlogs] = useState([]);

  // Helper function to strip HTML tags
  const stripHtmlTags = (html) => {
    if (!html) return "";
    const temp = document.createElement("div");
    temp.innerHTML = html;
    return temp.textContent || temp.innerText || "";
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [jobSeekersRes, blogsRes] = await Promise.all([
          fetch(
            `${config.API_BASE_URL}/content/job-seekers-blog-or-resources`,
          ).then((res) => res.json()),
          fetch(`${config.API_BASE_URL}/content/blog-or-resources`).then(
            (res) => res.json(),
          ),
        ]);

        const combined = [
          ...(jobSeekersRes.content || []),
          ...(blogsRes.content || []),
        ];

        // ✅ Remove duplicates by ID
        const uniqueBlogs = combined.filter(
          (blog, index, self) =>
            index === self.findIndex((b) => b.id === blog.id),
        );

        setBlogs(uniqueBlogs);
      } catch (err) {
        console.error("Error fetching blogs:", err);
      }
    };

    fetchData();
  }, []);

  const handleClick = () => {
    navigate("/about");
  };

  useEffect(() => {
    AOS.init({ duration: 1000 });

    fetch(`${config.API_BASE_URL}/banners/home`)
      .then((res) => res.json())
      .then((data) => {
        if (data.banners && data.banners.length > 0) {
          setBanner(data.banners[0]);
        }
      })
      .catch((err) => console.error("Banner fetch error:", err));

    axios
      .get(`${config.API_BASE_URL}/content/home`)
      .then((res) => {
        if (res.data?.content) {
          const sorted = [...res.data.content].sort(
            (a, b) => parseInt(a.content_order) - parseInt(b.content_order),
          );
          setSection1(sorted.find((item) => item.content_order === "1"));
          setSection2(sorted.find((item) => item.content_order === "2"));
          setSection3(sorted.find((item) => item.content_order === "3"));
          setSection4(sorted.find((item) => item.content_order === "4"));
          setSection5(sorted.find((item) => item.content_order === "5"));
          setSection6(sorted.find((item) => item.content_order === "6"));
          setSection7(sorted.find((item) => item.content_order === "7"));
          setSection8(sorted.find((item) => item.content_order === "8"));
        }
      })
      .catch((err) => console.error("Error fetching content:", err));

    axios
      .get(`${config.API_BASE_URL}/content/reviews`)
      .then((res) => {
        if (res.data?.content?.length > 0) {
          const formattedReviews = res.data.content.map((review) => ({
            id: review.id,
            title: review.content_title, // Reviewer Name & Designation
            text: review.content_text, // The review paragraph
            image: review.content_image, // Reviewer Image/Logo
          }));
          setReviews(formattedReviews);
        }
      })
      .catch((err) => {
        console.error("Error fetching reviews data:", err);
      });

    axios
      .get(`${config.API_BASE_URL}/content/home`)
      .then((res) => {
        if (res.data?.content) {
          const sortedData = [...res.data.content].sort(
            (a, b) => parseInt(a.content_order) - parseInt(b.content_order),
          );
          setContentData(sortedData);
        }
      })
      .catch((err) => console.error("Error fetching content:", err));
  }, []);

  function splitReviewsFromContentText(htmlString) {
    if (!htmlString) return [];

    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");

    const reviews = [];
    const h2Elements = doc.querySelectorAll("h2");

    h2Elements.forEach((h2) => {
      const imgP = h2.previousElementSibling;
      const reviewP = h2.nextElementSibling;

      if (imgP && reviewP) {
        const chunkHTML = imgP.outerHTML + h2.outerHTML + reviewP.outerHTML;
        reviews.push(chunkHTML);
      }
    });

    return reviews;
  }

  const blogPosts = [
    {
      title: "Gracefully Resign From Your Job: The Complete 2025 Guide",
      excerpt:
        "Ever notice how people who gracefully resign from their job seem to land on their feet faster? A polished exit preserves your network, protects your...",
      link: "https://www.prosapiens.co.in/wp/jobseekers/gracefully-resign-from-your-job-the-complete-2025-guide/",
      img: blogImg1,
    },
    {
      title: "Stand Out From the Start: Mastering Candidate Screening",
      excerpt:
        "Picture this: You've spent hours perfecting your resume and cover letter, only to find yourself faced with a set of seemingly simple questions that...",
      link: "https://www.prosapiens.co.in/wp/jobseekers/stand-out-from-the-start-mastering-candidate-screening/",
      img: blogImg2,
    },
    {
      title: "Applicant Tracking System: The Engine Behind Modern Hiring",
      excerpt:
        "Applicant Tracking System (ATS) software has quietly become the control-centre of hiring. In fact, more than 90 % of large employers rely on an ATS...",
      link: "https://www.prosapiens.co.in/wp/jobseekers/applicant-tracking-system-the-engine-behind-modern-hiring",
      img: blogImg3,
    },
  ];

  const getContent = (title) =>
    contentData.find((c) => c.content_title === title)?.content_text || "";

  const getImage = (title) =>
    contentData.find((c) => c.content_title === title)?.content_image || "";

  // Custom Arrow Components with improved styling
  const NextArrow = ({ onClick }) => (
    <button
      className="slick-arrow slick-next"
      onClick={onClick}
      aria-label="Next"
      type="button"
    >
      →
    </button>
  );

  const PrevArrow = ({ onClick }) => (
    <button
      className="slick-arrow slick-prev"
      onClick={onClick}
      aria-label="Previous"
      type="button"
    >
      ←
    </button>
  );

  // Blog slider settings
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  // Reviews slider settings with enhanced arrow configuration
  const reviewssettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: true,
        },
      },
    ],
  };

  return (
    <div className="home-container">
      <section className="hero-section">
        {banner && (
          <>
            <video className="hero-video" autoPlay muted loop playsInline>
              <source
                src={`/prosapiens-cms/public/${banner.banner_image}`}
                type="video/mp4"
              />
              Your browser does not support HTML5 video.
            </video>

            <div className="overlay container">
              <div
                className="hero-text"
                dangerouslySetInnerHTML={{ __html: banner.content_text }}
              />
              <Link
                to="/contact"
                className="cta-yellow"
                style={{ width: "280px" }}
              >
                HIRE AI-POWERED TALENT →
              </Link>
            </div>
          </>
        )}
      </section>

      <div>
        <section className="what-we-do">
          <div className="container">
            <div className="image-container">
              <div className="image-side" data-aos="fade-right">
                {getImage("content1") && (
                  <img
                    src={`/prosapiens-cms/public/${getImage(
                      "content1",
                    )}`}
                    alt="What We Do"
                  />
                )}
              </div>

              <div className="text-side" data-aos="fade-left">
                <div
                  dangerouslySetInnerHTML={{ __html: getContent("content1") }}
                />
                {/* <button className="cta-button">
                  HIRE EXCEPTIONAL TALENT →
                </button> */}

                <a href="/hire-about-prosapiens" className="cta-button">
                  HIRE EXCEPTIONAL TALENT →
                </a>
              </div>
            </div>
          </div>
        </section>

        {section2 && (
          <div
            className="container"
            dangerouslySetInnerHTML={{ __html: section2.content_text }}
          />
        )}

        {section3 && (
          <div
            className="container home-hiring"
            dangerouslySetInnerHTML={{ __html: section3.content_text }}
          />
        )}

        {section4 && (
          <div
            className="container"
            dangerouslySetInnerHTML={{ __html: section4.content_text }}
          />
        )}
      </div>

      <section className="slider-revievs">
        <div className="container">
          <div className="slider-box">
            <div className="reviews-text">
              <h1>Reviews</h1>
              <a href="company-reviews" className="cta-reviews">
                See All Reviews →
              </a>
            </div>
            <h2>
              Discover how top professionals have transformed their careers with
              our AI-driven hiring process.
            </h2>

            <div className="owl-carousel owl-theme">
              <Slider {...reviewssettings}>
                {reviews.length > 0 ? (
                  reviews.map((review, index) => (
                    <div className="item" key={index}>
                      <div className="review-card">
                        <div className="review-top">
                          {review.image && (
                            <img
                              src={`/prosapiens-cms/public/${review.image}`}
                              alt={review.title}
                              className="review-img"
                            />
                          )}
                          <h3 className="review-title">
                            {stripHtmlTags(review.title)}
                          </h3>
                        </div>
                        <div
                          className="review-text"
                          dangerouslySetInnerHTML={{ __html: review.text }}
                        />
                      </div>
                    </div>
                  ))
                ) : (
                  <p>Loading reviews...</p>
                )}
              </Slider>
            </div>
          </div>
        </div>
      </section>
      {section5 && (
        <div className="container">
          <div className="job-Openings-box">
            <h1>{section5.content_text.match(/<h1>(.*?)<\/h1>/)?.[1]}</h1>
            <p>{section5.content_text.match(/<p>(.*?)<\/p>/)?.[1]}</p>
            <button
              className="cta-yellow"
              onClick={() => navigate("/openings")}
            >
              Explore Job Openings →
            </button>
          </div>
        </div>
      )}

      {/* 7th section */}
      <div className="container">
        <div className="label">Blog</div>
        <div className="main-heading">
          Insights, trends, and expert advice to help you navigate and excel in
          the future of work.
        </div>

        {/* <Slider {...settings}>
            {blogPosts.map((post, index) => (
              <article className="article-card" key={index}>
                <div className="card-content">
                  <h2 className="article-title">{post.title}</h2>
                  <p className="article-excerpt">{post.excerpt}</p>
                  <a
                    href={post.link}
                    className="read-more-btn"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Read More →
                  </a>
                </div>
                <div className="card-image">
                  <img src={post.img} alt="Blog post" />
                </div>
              </article>
            ))}
          </Slider> */}
        <div className="owl-carousel owl-theme">
          <section className="blog-slider container">
            {blogs.length > 0 ? (
              <Slider {...settings}>
                {blogs.map((blog) => (
                  <div className="card-content" key={blog.id}>
                    <Link to={`/blogs/${blog.id}`}>
                      <div className="article-card">
                        <div className="blog-info">
                          {/* <h3 title={blog.content_title}>
                            {blog.content_title}
                          </h3> */}
                          <div
                            className="blog-excerpt"
                            dangerouslySetInnerHTML={{
                              __html: blog.content_text,
                            }}
                          />
                        </div>
                        {blog.content_image && (
                          <div className="card-image">
                            <img
                              src={`/prosapiens-cms/public/${blog.content_image}`}
                              alt={blog.content_title}
                              className="homeblog-img"
                            />
                          </div>
                        )}
                      </div>
                    </Link>
                  </div>
                ))}
              </Slider>
            ) : (
              <p>Loading blogs...</p>
            )}
          </section>
          {/* <Slider {...settings}>
            {blogs.map((blog) => (
              <article className="article-card" key={blog.id}>
                123
                <Link to={`/blogs/${blog.id}`}>
                  <div className="blog-content">
                    <div
                      className="blog-excerpt"
                      dangerouslySetInnerHTML={{ __html: blog.content_text }}
                    />
                    {blog.content_image && (
                      <div className="blog-image">
                        <img
                          src={`/prosapiens-cms/public/${blog.content_image}`}
                          alt={blog.content_title}
                        />
                      </div>
                    )}
                  </div>
                </Link>
              </article>
            ))}
          </Slider> */}
        </div>
      </div>

      <div className="divider"></div>

      <section className="home-video">
        <div className="container">
          <div className="video-text">
            <h1>See the Power of AI-Driven Hiring in Action</h1>
            <p>
              Watch real AI interview clips, resume analysis, and deep-dive reports — all in one place.
            </p>
          </div>
          <div className="video-wrapper bounce-in">
            <video controls preload="metadata">
              <source src={homepageVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </section>

      {section7 && (
        <div id="app">
          <div className="container">
            <div className="global-footprint" data-aos="fade-up">
              <div className="map-header">
                <h1 data-aos="fade-up" data-aos-delay="100">
                  {section7.content_text.match(/<h1.*?>(.*?)<\/h1>/)?.[1]}
                </h1>
                <p
                  className="description"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  {section7.content_text.match(/<p.*?>(.*?)<\/p>/)?.[1]}
                </p>
              </div>

              <div className="content">
                <div className="map-addr">
                  <div className="stats-panel">
                    {Array.from(
                      section7.content_text.matchAll(
                        /<div class="stat-card.*?">.*?<div class="stat-number">(.*?)<\/div>.*?<div class="stat-label">(.*?)<\/div>/gs,
                      ),
                    ).map(([, number, label], idx) => (
                      <React.Fragment key={idx}>
                        <div
                          className="stat-card"
                          data-aos="zoom-in"
                          data-aos-delay={300 + idx * 100}
                        >
                          <div className="stat-number">{number}</div>
                          <div className="stat-label">{label}</div>
                        </div>
                        <br />
                      </React.Fragment>
                    ))}
                  </div>

                  <div
                    className="map-container"
                    data-aos="fade-left"
                    data-aos-delay="600"
                  >
                    {section7.content_image && (
                      <img
                        src={`/prosapiens-cms/public/${section7.content_image}`}
                        alt="Global Map"
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {section8 && (
        <div className="container">
          <div className="job-Openings-box">
            <h1>{section8.content_text.match(/<h1.*?>(.*?)<\/h1>/)?.[1]}</h1>
            <p>{section8.content_text.match(/<p.*?>(.*?)<\/p>/)?.[1]}</p>
            <a href="contact" className="cta-yellow">
              Book a 10-Minute Discovery Call Now →
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
